import React from 'react';

const SystemError = () => {
    return (
        <div>This is SystemError Page</div>
    );
};

export default SystemError;